import React from 'react'

import { connect } from "react-redux"

import Banner from '../assets/Lobbyists header.png'
import BannerStripes from '../assets/header stripes.png'

import * as actionCreators from "../actionCreators/app.js"

import '../css/header.css'

const Header = ({ toggleMenu }) => {
  return (
    <div className="header-banner" id="header">
      <i className="menu-icon pi pi-bars" onClick={toggleMenu}></i>
      <div className="header-logo-title">
        <img src={Banner} alt={'South Australia Lobbyist Register'} className={"banner-image"} />
        <img src={BannerStripes} alt={'Banner stripes'} className={"banner-stripes-image"} />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

export default connect(mapStateToProps, actionCreators)(Header);


// WEBPACK FOOTER //
// ./src/container/Header.js